// extracted by mini-css-extract-plugin
export default {"header":"_3928431e","content":"_476e3708","headerContainer":"_e83a0c39","translationToggleContainer":"_521bcf9f","expandingAreaWrapper":"_67c68323"};